// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTabs_root__11OD1","tab":"ProcedureTabs_tab__2qOrv"};